<template>
    <input
        ref="datepickerInput"
        type="text"
        :id="id"
        v-bind:name="id"
        v-bind:data-umb="id"
        class="datepickerfield"
        data-val="true"
        autocomplete="off"
        v-bind:data-val-required="validationText"
    />
</template>

<script>
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";

export default {
    data() {
        return {
            datePickerInstance: null
        };
    },
    mounted() {
        const inputEl = this.$refs.datepickerInput;
        if (!inputEl) return;

        this.datePickerInstance = flatpickr(inputEl, {
            //static: true,
            //inline: true,
            future: true,
            minDate: new Date().fp_incr(7),
            disable: [
                function(date) {
                    // Disable weekends (Saturday = 6, Sunday = 0)
                    return date.getDay() === 0 || date.getDay() === 6;
                }
            ],
            dateFormat: 'd/m/Y',
            onChange: (selectedDates, dateStr) => {
                const hiddenField = document.getElementById(`${this.id}_1`);
                if (hiddenField) {
                    hiddenField.value = dateStr;
                }
            }
        });
    },
    beforeUnmount() {
        if (this.datePickerInstance) {
            this.datePickerInstance.destroy();
            this.datePickerInstance = null;
        }
    },

    methods: {

    },
    props: {
        id: {
            type: String,
            required: true
        },
        validationText: {
            type: String,
            required: true
        }
    },
};
</script>
